<script lang="ts">
    import {Link} from 'svelte-routing'
    import MainLayout from "../#common/layout/Layout.svelte"
    import IconifyIcon from '@iconify/svelte'
    import banIcon from '@iconify/icons-fa-solid/exclamation-triangle'
</script>

<svelte:head>
    <title>Account banned</title>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <div class="cabinet-wrapper">
            <div class="ban-text">
                <IconifyIcon icon={banIcon}/>
                <div class="title">Your Account Has Been Banned</div>
                <div class="description">Your Realis profile has been banned for activity that violates our <Link to="terms">Terms of Use</Link>.</div>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .ban-text {
        max-width: 550px;
        margin: 0 auto;
        padding-top: 20px;
        text-align: center;
        line-height: normal;
    }

    .ban-text :global(svg) {
        font-size: 60px;
        margin-bottom: 30px;
        color: white;
    }

    .title {
        font-size: 30px;
        color: white;
        margin-bottom: 20px;
        font-weight: 600;
    }

    .description {
        font-size: 20px;
        color: white;
        margin-bottom: 40px;
    }

    .ban-text .description :global a {
        color: white;
    }

    @media (max-width: 767px) {
        .ban-text {
            max-width: 390px;
        }

        .ban-text :global(svg) {
            font-size: 44px;
        }

        .title {
            font-size: 24px;
            margin-bottom: 15px;
        }

        .description {
            font-size: 16px;
            margin-bottom: 10px;
        }
    }
</style>
